import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/tabela/tabela-client.tsx");
